import { HelpCircle } from 'lucide-react';
import { GuideCategory } from './types';

export const troubleshootingGuide: GuideCategory = {
  id: 'troubleshooting',
  title: 'Troubleshooting',
  icon: HelpCircle,
  articles: [
    {
      slug: 'performance-tips',
      title: 'Performance & Optimization',
      description: 'How to keep your ball engine running smoothly on any device.',
      sections: [
        {
          id: 'browser-performance',
          title: 'Optimization for Browsers',
          content: 'Since our ball engine runs directly in your browser, its performance depends on your hardware. If you notice lag, try closing other heavy browser tabs or disabling Extensions that might interfere with WebGL.',
          tips: ['Use Chrome or Edge for the best WebGL performance results.']
        },
        {
          id: 'simulation-limits',
          title: 'Ball & Particle Limits',
          content: 'The number of active balls significantly impacts frame rate. If your simulation slows down, try reducing the spawn rate or using the "Clear All" button to reset the scene.',
          settingId: 'performance_settings_panel',
          technicalDetails: ['Recommended limit for mobile: 500 balls', 'Recommended limit for desktop: 5000 balls']
        },
        {
          id: 'low-power-mode',
          title: 'Low Power Mode',
          content: 'Enable "Performance Mode" in the Studio settings. This reduces visual effects like high-res glow and complex trailing to ensure the core ball physics stay fast and responsive.',
          settingId: 'low_power_mode_toggle'
        }
      ]
    },
    {
      slug: 'frequently-asked-questions',
      title: 'Common Questions',
      description: 'Quick answers to the most common user issues.',
      sections: [
        {
          id: 'no-audio-sync',
          title: 'Why is there no audio sync?',
          content: 'Ensure your audio is playing and your "Beat Sensitivity" slider isn\'t set to zero. Also, make sure you are in a mode that supports audio sync, like "Rhythmic Mode".',
          tips: ['Check if your browser has muted the tab automatically.']
        },
        {
          id: 'missing-presets',
          title: 'Where are my saved presets?',
          content: 'Presets are saved to your account in the cloud. Make sure you are logged in to see your full library. If you were using the guest mode, presets are only saved locally in your current browser.',
          settingId: 'account_sync_notice'
        },
        {
          id: 'recording-errors',
          title: 'Video Recording Issues',
          content: 'If your recording fails, it usually means your device ran out of memory. Try a shorter recording or use our "Cloud Render" feature to offload the work to our servers.',
          tips: ['For the best stability, keep local recordings under 60 seconds.']
        }
      ]
    }
  ]
};
